import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { store } from './store';
import theme from './theme';
import './index.css'; 
import setupAxiosInterceptors from './utils/axiosInterceptor';
import { QueryProvider } from './providers/QueryProvider';
import { MotionConfig } from 'framer-motion';
import { initAnalytics } from './utils/analytics';

if (process.env.NODE_ENV === 'production') {
  console.log = () => undefined;
  console.warn = () => undefined;
  console.error = () => undefined;
}

// Setup axios interceptors for JWT expiration handling
setupAxiosInterceptors();
initAnalytics();

// Global error handlers
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  
  // Don't show user notification for network errors (already handled by axios interceptor)
  if (event.reason?.message?.includes('Network Error') || 
      event.reason?.message?.includes('timeout')) {
    return;
  }
  
  // Show user-friendly error message for other unhandled rejections
  const errorMessage = event.reason?.message || 'An unexpected error occurred';
  console.error('Unhandled error will be shown to user:', errorMessage);
  
  // Prevent the default browser error handling
  event.preventDefault();
});

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  
  // Log error details for debugging
  console.error('Error details:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    stack: event.error?.stack
  });
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryProvider>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <MotionConfig reducedMotion="user">
            <App />
          </MotionConfig>
        </ThemeProvider>
      </BrowserRouter>
      </QueryProvider>
    </Provider>
  </React.StrictMode>
); 